import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() { this.show("flow") }

  select(event) {
    const view = event.currentTarget.dataset.view
    this.show(view)
    if (event.currentTarget.getAttribute("role") !== "tab") {
      this.tabTargets.find(tab => tab.dataset.view === view)?.focus({ preventScroll: true })
    }
  }

  navigate(event) {
    const keys = ["ArrowLeft", "ArrowRight", "Home", "End"]
    if (!keys.includes(event.key)) return
    event.preventDefault()
    const current = this.tabTargets.indexOf(event.currentTarget)
    const last = this.tabTargets.length - 1
    const index = event.key === "Home" ? 0 : event.key === "End" ? last : (current + (event.key === "ArrowRight" ? 1 : last)) % this.tabTargets.length
    this.show(this.tabTargets[index].dataset.view)
    this.tabTargets[index].focus()
  }

  show(view) {
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.view === view
      tab.setAttribute("aria-selected", String(active))
      tab.tabIndex = active ? 0 : -1
    })
    this.panelTargets.forEach(panel => { panel.hidden = panel.dataset.view !== view })
  }
}
